import React, { useState } from "react";
import PropTypes from "prop-types";
import AdminNavbar from "component/common/Navbar";
import "./mainlayout.scss";
import { Sidebar } from "component/common/Sidebar";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export function MainLayout(props) {
  const { children } = props;

  const [isOpen, setOpen] = useState(true);
  const location = useLocation();


  const toggle = () => {
    setOpen(!isOpen);
  };

  return (
    // <div className="admin-layout">
    //   <Sidebar isOpen={isOpen} />

    //   <div className={`main-layout`}>
    //     <div className="main-layout-wrapper">
    //       <AdminNavbar isOpen={isOpen} toggle={toggle} />
    //       <main
    //         className={`${location.pathname !== "/notification"
    //           ? "main-content-wrapper"
    //           : "notification-content-wrapper"
    //           } ${isOpen ? "open-layout" : "closed-layout"}`}
    //       >
    //         {children}
    //       </  main>
    //     </div>
    //   </div>
    // </div>

    <div className="app-wrapper">
      <Sidebar isOpen={isOpen} />

      <div className={`main-area ${isOpen ? "sidebar-open" : "sidebar-closed"}`}>
        <AdminNavbar isOpen={isOpen} toggle={toggle} />

        <main
          className={`page-content ${location.pathname === "/notification" ? "notification-page" : ""
            }`}
        >
          {children}
        </main>
      </div>
    </div>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
